import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

import WhiteButton from "../components/v2/WhightButton";
import requestDemoBGImg from "../images/v2/request-demo-bg.svg";
import testimonialBannerBg from "../images/v2/testimonial-bg@2x.png";
import useWidth from "../hooks/useWidth";
import SEO from "../components/SEO";
import { Link } from "gatsby";
import TestimonialCard from "../components/v2/TestimonialCard";
import { StaticImage } from "gatsby-plugin-image";
import { useState } from "react";
import img1 from "../images/v2/client-logos/singaporeFoundation.png";
import img2 from "../images/v2/client-logos/techDataLogo.png";
import img3 from "../images/v2/client-logos/msscLogo.png";
import img4 from "../images/v2/client-logos/sisLogo.png";
// import img5 from "../images/v2/client-logos/cuscapi-singapore-pte-ltd-pepper-cloud-customer.png";
import img5 from "../images/v2/client-logos/cuscapiLogo.png";
import img6 from "../images/v2/client-logos/techDataLogo.png";
import img7 from "../images/v2/client-logos/skypac-pepper-cloud-customer.png";
import img8 from "../images/v2/client-logos/supremeLogo.png";
import img9 from "../images/v2/client-logos/cashmartLogo.png";
import img10 from "../images/v2/client-logos/tofuLogo.png";
import img11 from "../images/v2/client-logos/aamsLogo.png";
import img12 from "../images/v2/client-logos/caffeineLogo.png";
import img13 from "../images/v2/client-logos/kossLogo.png";
import img14 from "../images/v2/client-logos/fireFlyLogo.png";
import img15 from "../images/v2/client-logos/mLogo.png";
import img16 from "../images/v2/client-logos/exoticLogo.png";
import img17 from "../images/v2/client-logos/incLogo.png";
import img18 from "../images/v2/client-logos/regentLogo.png";
import img19 from "../images/v2/client-logos/vootours.png";
import img20 from "../images/v2/client-logos/kristal.png";
import img21 from "../images/v2/client-logos/manHoTravel.png";
import img22 from "../images/v2/client-logos/deluxeLogo.png";
import img23 from "../images/v2/client-logos/everglossLogo.png";
import img24 from "../images/v2/client-logos/travelworkz.png";
import img25 from "../images/v2/client-logos/edengrace.png";
import img26 from "../images/v2/client-logos/getgo.png";
import img27 from "../images/v2/client-logos/artistate.png";
import img28 from "../images/v2/client-logos/thehairlabel.png";
import img29 from "../images/v2/client-logos/platinum.png";
import img30 from "../images/v2/client-logos/mirage.png";
import img31 from "../images/v2/client-logos/tiny.png";
import img32 from "../images/v2/client-logos/gleamauto.png";
import img33 from "../images/v2/client-logos/euHoliday.png";
import orangeArrow from "../images/v2/client-logos/orangeArrow.svg";

import leftDisabledArrow from "../images/v4/logos/leftDisabledArrow.svg";
import rightDisabledArrow from "../images/v4/logos/rightDisabledArrow.svg";
import leftArrow from "../images/v4/logos/leftArrow.svg";
import rightArrow from "../images/v4/logos/rightArrow.svg";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  img: {
    maxWidth: "100%",
    height: "auto",
  },
  requestDemoRoot: {
    background: `url(${requestDemoBGImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  testimonialBanner: {
    background: `url(${testimonialBannerBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: "10rem 0",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "5rem 0",
    },
  },
  nextImg: {
    /* Centering styles */
    // top: 50%,
    // left: 50%,
    // transform: translate(-50%, -50%);
    // alignItems: "center",
    // justifyContent : "center",

    /* Size styles */
    width: "300" /* Adjust width as needed */,
    height: "200" /* Adjust height as needed */,
  },
  togglerIcon: {
    width: "60px",
    transition: "0.5s ease",
    transform: "rotate(180deg)",
    "&.active": {
      transform: "rotate(0deg)",
    },
  },
}));

const TestimonialPage = () => {
  const width = useWidth();
  const classes = useStyles();

  const [activePage, setActivePage] = useState(0);

  const previousPage = () => {
    if (activePage === 0) {
      return;
    } else {
      setActivePage(activePage - 1);
      window.scrollTo({ top: 300, behavior: "smooth" });
    }
  };

  const nextPage = () => {
    if (activePage === 3) {
      return;
    } else {
      setActivePage(activePage + 1);
      window.scrollTo({ top: 300, behavior: "smooth" });
    }
  };

  const clientsPage1 = [
    {
      image: (
        <StaticImage
          alt="Pepper Cloud+Singapore Maritime Foundation"
          height="108"
          src="../images/v2/testimonial/wilson-tan-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Singapore Maritime Foundation - Pepper Cloud customer"
          height="35"
          src={img1}
        />
      ),
      name: "Wilson Tan",
      position: "Senior Manager",
      company: "Singapore Maritime Foundation, Singapore",
      contentSmall: `“Pepper Cloud is a best  CRM tool to improve coordination among SMF departments and improve our database management.”`,
      content: (
        <React.Fragment>
          Pepper Cloud is a best CRM tool to improve coordination among SMF
          departments and improve our database management. The user-friendly
          interface, easy-to-use functions, and customisable features meant we
          could set up, integrate, and onboard the whole team on the cloud
          platform quickly. We appreciate the support and responsiveness of the
          Pepper Cloud team during the implementation process! I must say its a
          Singapore’s best CRM software specially for SMEs.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud+TechData Corporation"
          height="108"
          src="../images/v2/testimonial/yoon-kam-fei-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="Tech Data - Pepper Cloud customer" height="35" src={img2} />
      ),
      name: "Yoon Kam Fei",
      position: "Managing Director",
      company: "Tec D Distribution Sdn Bhd, Malaysia",
      content: (
        <React.Fragment>
          Team collaboration, accurate sales forecasting, and effective resource
          management are the challenges every organisation encounters. But
          having an efficient CRM tool like Pepper Cloud enhances productivity
          while assisting in optimising the sales process and managing the sales
          pipeline. Pepper Cloud CRM tool is the right mix of flexibility,
          affordability, and ease of use.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Mustard Seed System Corporation"
          height="108"
          src="../images/v2/testimonial/judith-adao-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Mustard seed system corporation - Pepper Cloud customer"
          height="35"
          src={img3}
        />
      ),
      name: "Judith M. Adao",
      position: "General Manager",
      company: "Mustard Seed Systems Corporation, Philippines",
      content: (
        <React.Fragment>
          Pepper Cloud is a simple and easy-to-use CRM tool and it gives all the
          information needed to manage the sales leads. The CRM also helps us to
          run data-driven marketing campaigns. Pepper Cloud's customer service
          and local support are incredible and helped us at every stage of the
          implementation. This CRM software is a must for every growing sales
          organisation.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Cuscapi Singapore Pte. Ltd."
          height="108"
          // src="../images/v2/testimonial/anthony-gerald-peppercloud-customer.png"
          src="../images/v2/testimonial/anthony-gerald-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Cuscapi Singapore Pte. Ltd. - Pepper Cloud customer"
          height="35"
          src={img5}
        />
      ),
      name: "Anthony Gerald",
      position: "Group CEO",
      company: "Cuscapi Berhad, Malaysia",
      content: (
        <React.Fragment>
          The CRM Solution has a strong sales pipeline management tool that
          helps us to manage our business operations in 6 countries. It has a
          robust user management system with clearly defined access levels for
          data security and protection, which we needed. What I personally like
          the most in Pepper Cloud CRM is its service dedication and personal
          touch. There is a face behind the product to whom we can reach out to
          whenever there is a problem.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + SiS Distribution (Thailand) PCL"
          height="108"
          src="../images/v2/testimonial/pantana-na-takuathung-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="SiS Distribution - Pepper cloud customer"
          height="35"
          src={img4}
        />
      ),
      name: "Pantana Na Takuathung",
      position: "General Manager",
      company: "SiS Distribution (Thailand) Public Co., Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud is an excellent all-in-one CRM system to run multiple
          businesses across multiple domains. Through multiple sales pipelines,
          we track the business opportunities and the conversations between our
          team and our customers. Furthermore, this CRM software boosts the
          sales productivity of our team by helping us focus on core processes.
        </React.Fragment>
      ),
    },

    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Tech Data Corporation Client"
          height="108"
          src="../images/v2/testimonial/sally-see-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="Tech Data - Pepper Cloud customer" height="35" src={img6} />
      ),
      name: "Sally See",
      position: "Marketing Manager",
      company: "Tec D Distribution Sdn Bhd, Malaysia",
      content: (
        <React.Fragment>
          Pepper Cloud CRM has made real-time data accessible to everyone in the
          company. Its association feature allows linking the business and
          activity records, helping us to track past and present customer
          interactions and allowing a higher level opportunity conversion.
          Additionally, Pepper Cloud CRM takes our feedback seriously. We feel
          that we do have a say in the product roadmap.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Skypac Packaging Pte Ltd Client"
          height="108"
          src="../images/v2/testimonial/kelvin-peppercloud-customer.jpg"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Skypac Packaging - Pepper Cloud customer"
          height="35"
          src={img7}
        />
      ),
      name: "Kelvin Yeo",
      position: "Director",
      company: "Skypac Packaging Pte Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud is easy to use, flexible, and scalable CRM software,
          which is helping us to streamline our sales process, cut down
          repetitive tasks and increase our work efficiency. The support and
          training offered by the team are impeccable. Pepper Cloud perfectly
          fits the requirements of Singapore SMEs. The solution is also a part
          of ‘SME Go Digital’ and pre-approved under the PSG grant that made us
          more confident on this solution.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + The supreme hr advisory"
          height="108"
          src="../images/v2/testimonial/joel-toh-peppercloud-customer.jpg"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="The supreme hr advisory - Pepper Cloud customer"
          height="35"
          src={img8}
        />
      ),
      name: "Joel Toh",
      position: "Director",
      company: "The Supreme HR Advisory",
      content: (
        <React.Fragment>
          Pepper Cloud is a sales-focused CRM that is helping our business to
          grow. The user interface is easy and our sales process is now more
          organised. Apart from the highly productive CRM features, we are happy
          with their exceptional support and relentless assistance. Also, Pepper
          Cloud rolls out new features as per the feedback and customer
          requirements. We are happy with the product and the people behind the
          product.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + The supreme hr advisory"
          height="108"
          src="../images/v2/testimonial/jimmy-lee-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="Cashmart - Pepper Cloud customer" height="45" src={img9} />
      ),
      name: "Jimmy Lee",
      position: "Managing Director",
      company: "Cash Mart Pte. Ltd.",
      content: (
        <React.Fragment>
          Our growing sales team always faced issues with team collaboration,
          communication, and sales planning. After implementing Pepper Cloud
          CRM, most of the challenges were resolved in no time. The CRM system
          helped us manage our leads and sales pipelines and provided us with a
          unified platform to collaborate and communicate internally. We are
          extremely pleased with this solution and would definitely recommend
          it.
        </React.Fragment>
      ),
    },
  ];

  const clientsPage2 = [
    {
      image: (
        <StaticImage
          alt="Pepper Cloud+AAMS"
          height="108"
          src="../images/v2/testimonial/Keith-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="AAMS - Pepper Cloud customer" height="45" src={img11} />
      ),
      url: null,
      name: "Keith",
      position: "Manager",
      company: "AAMS",
      content: (
        <React.Fragment>
          After thoroughly evaluating a range of CRM options, our selection of
          Pepper Cloud CRM was primarily motivated by their in-depth grasp of
          our business operations. Right from the beginning, it was evident that
          Pepper Cloud CRM wasn't simply a software provider but a partner who
          understood the intricacies of our business operations. This level of
          comprehension was pivotal in aligning the CRM with our unique needs.
          Furthermore, the ability to customise the CRM system as per our needs
          proved highly valuable in efficiently managing our business.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Firefly Photography Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/Benny-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Firefly Photography Pte. Ltd. - Pepper Cloud customer"
          height="55"
          src={img14}
        />
      ),
      url: null,
      name: "Benny",
      position: "Creative Director",
      company: "Firefly Photography Pte. Ltd.",
      content: (
        <React.Fragment>
          Incorporating Pepper Cloud CRM for our business was smooth and
          hassle-free. The onboarding process was well-guided, and the training
          resources provided by their team facilitated a smooth transition for
          our employees to adapt to the new system. In a remarkably short
          period, we became fully accustomed to the CRM system and started
          experiencing its benefits. Thanks to Pepper Cloud.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Exotic Office Solution."
          height="108"
          src="../images/v2/testimonial/Jaden-Tan-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Exotic Office Solution - Pepper Cloud customer"
          height="45"
          src={img16}
        />
      ),
      url: null,
      name: "Jaden Tan",
      position: "Director",
      company: "Exotic Office Solution",
      content: (
        <React.Fragment>
          Pepper Cloud, a user-friendly CRM, is seamlessly integrated into our
          workflow, providing robust lead management, efficient contact
          organisation, and valuable analytics. This streamlined our daily
          operations, enabling more time for deal closure and data-driven
          decision-making. Their responsive customer support and tangible ROI,
          including increased sales, satisfaction, and cost savings, have truly
          transformed our operations.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Vootours"
          height="108"
          src="../images/v2/testimonial/anis.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="Vootours - Pepper Cloud customer" height="60" src={img19} />
      ),
      url: null,
      name: "Anis Yusuff",
      position: "General manager",
      company: "Vootours",
      content: (
        <React.Fragment>
          We were looking for an easy-to-use and reliable CRM solution. While
          other CRMs were impressive, they didn't align with our business needs.
          Upon evaluating Pepper Cloud CRM, we discovered the perfect blend of
          powerful features and user-friendly design. It captured all essential
          aspects of larger CRMs, yet its intuitive interface was an ideal match
          for us. Additionally, Pepper Cloud CRM offered exceptional
          round-the-clock support which was critical for growing business like
          ours. Their feature and functionality and their proactive assistance
          made it a perfect choice for us and greatly enhanced our experience.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Kristal"
          height="108"
          src="../images/v2/testimonial/vineeth.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="Kristal - Pepper Cloud customer" height="60" src={img20} />
      ),
      url: null,
      name: "Vineeth Narasimhan",
      position: "CEO",
      company: "Kristal",
      content: (
        <React.Fragment>
          Pepper Cloud CRM has transformed how we engage with clients. Its
          integration with WhatsApp, email, and more makes staying connected
          with our customers seamless. Response times are faster, AI automation
          features handle routine tasks, and our sales process is more
          efficient. We’ve improved workflows while maintaining a personal touch
          — and it’s reflected in our improved NPS score. We’re truly impressed
          with the difference it has made in our client servicing!
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Nam ho travel"
          height="108"
          src="../images/v2/testimonial/ooi.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Nam ho travel - Pepper Cloud customer"
          height="60"
          src={img21}
        />
      ),
      url: null,
      name: "Ooi Hui Hong Irene",
      position: "Director",
      company: "Nam ho travel",
      content: (
        <React.Fragment>
          Pepper Cloud CRM has completely transformed how we work! The
          onboarding was easy, the team is incredibly supportive, and the
          WhatsApp integration has taken our client communication to the next
          level. With WhatsApp CRM integration, we can respond faster, track
          conversations, and keep everything in one place. Not just that, we are
          also more organized, faster, and building stronger relationships every
          day.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Deluxe printing"
          height="108"
          src="../images/v2/testimonial/nayeem.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Deluxe printing - Pepper Cloud customer"
          height="60"
          src={img22}
        />
      ),
      url: "https://www.dlxprint.com/",
      name: "Nayeem Momin",
      position: "Regional Manager",
      company: "Deluxe printing",
      content: (
        <React.Fragment>
          As our business grew, we struggled with collaboration, lead
          management, & manual tasks. Pepper Cloud AI chatbot changed how we
          work—automating routine queries, lead qualification, & conversation
          assignments. The sales automation & real-time tracking features
          streamlined our workflows. Pepper Cloud also has a responsive support
          team & offers CRM software that evolves with user feedback. Overall,
          it’s a smart, reliable CRM that every sales-driven team should
          consider.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Maven Brokers Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/amoswong.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Maven Brokers Pte. Ltd. - Pepper Cloud customer"
          height="55"
          src={img25}
        />
      ),
      url: null,
      name: "Amos Wong",
      position: "Deputy Director",
      company: "Maven Brokers Pte. Ltd.",
      content: (
        <React.Fragment>
          Pepper Cloud AI WhatsApp Sales CRM is a useful and productive tool for
          us. Packed with powerful features and easy usability, our sales team
          is able to work with confidence. Customer communication has improved,
          thanks to its native WhatsApp integration and workflow automation. The
          support system of the company is also very good. Always helpful and
          easy to reach out, which is essential for SMEs like us. If you want a
          CRM that works with your team, Pepper Cloud AI CRM system delivers!
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + 707-inc Great Excursion Travel Pte Ltd"
          height="108"
          src="../images/v2/testimonial/jhonsonlim.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="707-inc Great Excursion Travel Pte Ltd - Pepper Cloud customer"
          height="60"
          src={img26}
        />
      ),
      url: null,
      name: "Jhonson Lim",
      position: "Deputy Director",
      company: "707-inc Great Excursion Travel Pte Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud AI WhatsApp Sales CRM brought all of our needs under one
          roof. The team didn’t just hand over the software, instead they took
          time to understand how we work and guided us through making the CRM
          work for us.
        </React.Fragment>
      ),
    },
  ];

  const clientsPage3 = [
    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Maven Brokers Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/Sky-Tan-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Maven Brokers Pte. Ltd. - Pepper Cloud customer"
          height="55"
          src={img15}
        />
      ),
      url: null,
      name: "Sky Tan",
      position: "Marketing Manager",
      company: "Maven Brokers Pte. Ltd.",
      content: (
        <React.Fragment>
          Being an SME, we needed reliable support after implementing the
          product. The Pepper Cloud team has been incredibly helpful, responding
          promptly through WhatsApp, email, and phone calls. They actively
          listen to our feedback and address our concerns. We highly recommend
          them to fellow local SMEs.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + 707-inc Great Excursion Travel Pte Ltd"
          height="108"
          src="../images/v2/testimonial/Joshua Kiong-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="707-inc Great Excursion Travel Pte Ltd - Pepper Cloud customer"
          height="60"
          src={img17}
        />
      ),
      url: null,
      name: "Joshua Kiong",
      position: "Manager (Advisor)",
      company: "707-inc Great Excursion Travel Pte Ltd",
      content: (
        <React.Fragment>
          Implementing Pepper Cloud CRM was seamless with their helpful
          onboarding and training resources. It's our perfect CRM solution,
          meeting all our needs (such as tracking sales, automating workflows,
          and integrating with various platforms) and offering proactive
          round-the-clock support. The WhatsApp CRM also helped us streamline
          customer conversations and enable seamless interaction tracking,
          ultimately leading to increased productivity and efficiency.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Regent Maid Agency Pte Ltd"
          height="108"
          src="../images/v2/testimonial/Stephanie-Chew-peppercloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Regent Maid Agency Pte Ltd - Pepper Cloud customer"
          height="60"
          src={img18}
        />
      ),
      name: "Stephanie Chew",
      position: "Managing Director",
      company: "Regent Maid Agency Pte Ltd",
      content: (
        <React.Fragment>
          We embarked on a digital journey with Pepper Cloud and it has really
          worked for us. The CRM software has helped us to organise business and
          let us focus on improving our customer outreach and relationships.
          Now, we don’t have to spend time manually working in Excel sheets and
          creating reports, etc. The company support is perfect and they are
          always approachable on WhatsApp/Email/Phone.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud+Tofu Technologies Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/Chiua-Ai-Zhen Dionis-pepper-cloud-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Tofu Technologies Pte. Ltd. - Pepper Cloud customer"
          height="45"
          src={img10}
        />
      ),
      name: "Chiua Ai Zhen Dionis",
      position: "Director",
      company: "Tofu Technologies Pte. Ltd.",
      contentSmall: `“Pepper Cloud is an excellent CRM solution that has helped us to level up our performance by efficiently managing our customer and sales pipeline.”`,
      content: (
        <React.Fragment>
          Pepper Cloud is an excellent CRM solution that has helped us to level
          up our performance by efficiently managing our customer and sales
          pipeline. Since the solution is on the cloud, we can access all
          customer information anytime, anywhere. We get full visibility into
          our sales pipeline and also a comprehensive report on our incoming
          leads. The system is user-friendly and a great CRM for SMEs seeking to
          embrace digitalisation.
        </React.Fragment>
      ),
    },

    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Caffeine Solutions Pvt. Ltd"
          height="108"
          src="../images/v2/testimonial/Ben Fones-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Caffeine Solutions Pvt. Ltd - Pepper Cloud customer"
          height="45"
          src={img12}
        />
      ),
      name: "Ben Fones",
      position: "Director",
      company: "Caffeine Solutions Pvt. Ltd",
      content: (
        <React.Fragment>
          This CRM solution is perfect for SMEs like ours. Our sales team has
          become more efficient and proactive. With this CRM, our team stays
          connected and can easily track sales activities in an organized
          manner. It's a comprehensive sales CRM with excellent features. The
          after-sales support is pleasantly very responsive and supportive. I
          highly recommend this CRM software for SMEs.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + KCSS Pest Management Pte. Ltd"
          height="108"
          src="../images/v2/testimonial/SivaKumar Subramani-customer.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="KCSS Pest Management Pte. Ltd - Pepper cloud customer"
          height="45"
          src={img13}
        />
      ),
      name: <span>SivaKumar Subramani</span>,
      position: "Director",
      company: "KCSS Pest Management Pte. Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud CRM helps us manage our sales efficiently. It was simple
          to set up, and the easy-to-use interface allowed us to quickly focus
          on sales by planning our day-to-day sales activities. Its multiple
          message channel integration helps us to manage sales on the go. Their
          sales tracking & forecasting feature is very helpful for our team.
          This makes all the difference for a growing sales organisation like
          ours. Thank you, Pepper Cloud!
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + evergloss"
          height="108"
          src="../images/v2/testimonial/kent.png"
          width="113"
        />
      ),
      clientLogo: (
        <img alt="evergloss - Pepper cloud customer" height="45" src={img23} />
      ),
      name: <span>Kent Xu</span>,
      position: "General Manager",
      company: "evergloss",
      content: (
        <React.Fragment>
          Pepper Cloud AI CRM is a smart investment for any business looking to
          save time, streamline operations, and manage customer relationships
          more effectively. It helps streamline processes and drive better
          results across teams. Pepper Cloud customer support team is excellent
          as well. They are always responsive, friendly, and ready to help.
          Highly recommended for any growing business.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + travelworkz"
          height="108"
          src="../images/v2/testimonial/hoKahLiong.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="travelworkz - Pepper cloud customer"
          height="45"
          src={img24}
        />
      ),
      name: <span>Ho Kah Liong, Shaun</span>,
      position: "Director",
      company: "travelworkz",
      content: (
        <React.Fragment>
          Pepper Cloud AI-powered CRM has greatly improved our customer
          communication, especially through WhatsApp & other platforms. Its
          automation & integrations have streamlined operations, boosting
          productivity & sales while letting us focus on creating great travel
          experiences. We're also impressed with Pepper Cloud support team. They
          support us relentlessly, & their solutions are always quick &
          efficient. Their dedication ensures that we can focus on our core
          business without disruption.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + travelworkz"
          height="108"
          src="../images/v2/testimonial/chan.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="travelworkz - Pepper cloud customer"
          height="45"
          src={img27}
        />
      ),
      name: <span>Chan Kai Bin Gerald</span>,
      position: "Executive Director",
      company: "travelworkz",
      content: (
        <React.Fragment>
          Thanks to Pepper Cloud, we are now able to efficiently manage our
          sales, integrate our messaging apps, and automate the sales processes.
          We are also happy with the support and assistance provided by Pepper
          Cloud. The team is driven to resolve customers’ challenges. Good
          investment.
        </React.Fragment>
      ),
    },
  ];

  const clientsPage4 = [
    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Maven Brokers Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/jeslin.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Maven Brokers Pte. Ltd. - Pepper Cloud customer"
          height="55"
          src={img30}
        />
      ),
      url: null,
      name: "Jeslin Tan",
      position: "Senior Marketing Executive",
      company: "Maven Brokers Pte. Ltd.",
      content: (
        <React.Fragment>
          Pepper Cloud CRM has made our business operations convenient and
          effortless with highly useful features. We are able to efficiently
          manage our customer conversations, and automate the business
          processes. The CRM is easy to set up and the simple user interface
          helps us focus on the day-to-day sales activities right away. We are
          impressed by the quick support of Pepper Cloud and its team. They
          provide one-to-one support.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + 707-inc Great Excursion Travel Pte Ltd"
          height="108"
          src="../images/v2/testimonial/joshua.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="707-inc Great Excursion Travel Pte Ltd - Pepper Cloud customer"
          height="60"
          src={img29}
        />
      ),
      url: null,
      name: "Joshua Yap Eng Leong",
      position: "Director",
      company: "707-inc Great Excursion Travel Pte Ltd",
      content: (
        <React.Fragment>
          As our sales team began to scale, we encountered challenges with
          internal communication, collaboration, and consistent sales planning.
          Pepper Cloud streamlined our workflows, providing us with a unified
          space where sales activities, team conversations, and planning all
          came together. Pepper Cloud AI-powered sales CRM didn’t just resolve
          our existing challenges, it elevated our sales process altogether.
          It’s intuitive, reliable, and has become an essential part of our
          daily operations.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud + Regent Maid Agency Pte Ltd"
          height="108"
          src="../images/v2/testimonial/jin.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Regent Maid Agency Pte Ltd - Pepper Cloud customer"
          height="60"
          src={img28}
        />
      ),
      name: "Jin Ming",
      position: "Manager",
      company: "Regent Maid Agency Pte Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud didn’t just give us a sales tool—it gave us a scalable
          platform. We love the WhatsApp integration, which allows our sales
          team to connect with leads and customers instantly and track all
          conversations within the CRM. This has improved our responsiveness and
          customer engagement significantly. The onboarding process was smooth,
          and Pepper Cloud’s team provided structured training to get us fully
          operational quickly.
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud+Tofu Technologies Pte. Ltd."
          height="108"
          src="../images/v2/testimonial/evelyn.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Tofu Technologies Pte. Ltd. - Pepper Cloud customer"
          height="45"
          src={img32}
        />
      ),
      name: "Evelyn Ow",
      position: "Manager",
      company: "Tofu Technologies Pte. Ltd.",
      contentSmall: `“Pepper Cloud is an excellent CRM solution that has helped us to level up our performance by efficiently managing our customer and sales pipeline.”`,
      content: (
        <React.Fragment>
          We’ve been using Pepper Cloud CRM at Gleam Auto for a while now, and
          so far we are happy with it. Before, we were tracking everything
          manually—calls, bookings, follow-ups—it was a bit messy. With Pepper
          Cloud CRM, it's way easier to keep tabs on customers and stay on top
          of things. It doesn’t feel overly complicated, and the support team
          actually listens when you have questions. It just works for how we run
          things day to day.
        </React.Fragment>
      ),
    },

    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Caffeine Solutions Pvt. Ltd"
          height="108"
          src="../images/v2/testimonial/sharon.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Caffeine Solutions Pvt. Ltd - Pepper Cloud customer"
          height="45"
          src={img31}
        />
      ),
      name: "Sharon Seow",
      position: "Founder",
      company: "Caffeine Solutions Pvt. Ltd",
      content: (
        <React.Fragment>
          Pepper Cloud CRM has brought a whole new level of convenience and
          efficiency to our business! From the seamless integration with our
          existing tools like Office 365 and WhatsApp to the intuitive and
          user-friendly interface, everything just works. Our team was able to
          get started with minimal training, which speaks volumes about how
          well-designed the platform is. All in all, Pepper Cloud CRM has helped
          us stay organized, close deals faster, and serve our clients better.
          Highly recommended!
        </React.Fragment>
      ),
    },
    {
      image: (
        <StaticImage
          alt="Pepper Cloud +  Eu holidays"
          height="108"
          src="../images/v2/testimonial/kevin.png"
          width="113"
        />
      ),
      clientLogo: (
        <img
          alt="Eu holidays - Pepper Cloud customer"
          height="45"
          src={img33}
        />
      ),
      name: "Kevin Cheng",
      position: "Manager",
      company: "Eu holidays",
      content: (
        <React.Fragment>
          We transitioned to Pepper Cloud, an AI-driven Sales CRM system
          primarily for its sales pipeline management and WhatsApp integration
          features. Our decision was further strengthened by their exceptional
          support and intelligent automation capabilities. The onboarding
          process was smooth and efficient, enabling our team to adapt quickly,
          and the upgrade was cost-effective
        </React.Fragment>
      ),
    },
  ];

  const combinedClients = [
    ...clientsPage1,
    ...clientsPage2,
    ...clientsPage3,
    ...clientsPage4,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNextClick = () => {
    if (currentIndex + 9 < combinedClients.length) {
      setCurrentIndex(currentIndex + 9);
    }
  };

  const handlePreviousClick = () => {
    if (currentIndex - 9 >= 0) {
      setCurrentIndex(currentIndex - 9);
    }
  };

  return (
    <React.Fragment>
      <SEO
        canonical="/crm-testimonials/"
        description="Read the customers' experiences about Singapore's #1 sales CRM, Pepper Cloud.
        Pepper Cloud is an excellent all-in-one CRM tool to run multiple businesses across multiple domains."
        keywords="customer experience, sales process, CRM tool"
        ogData={{
          "og:image": [
            "/meta/og/1X1/testimonials.png",
            "/meta/og/1024X512/testimonials.png",
            "/meta/og/1200X630/testimonials.png",
          ],
        }}
        pathname="/crm-testimonials/"
        title="Customer testimonials | Pepper Cloud CRM"
      />
      <Box className={classes.testimonialBanner}>
        <Container>
          <Box textAlign={{ sm: "center", xs: "center" }}>
            <HeaderTypography component="h1" fontWeight={700} m={0} pb={4}>
              Our happy customers share their experiences
            </HeaderTypography>
            <ParagraphTypography m={0}>
              Read our customer experiences. Discover how small and medium
              businesses across the globe found solutions for their different
              business needs <br /> with Pepper Cloud CRM software.
            </ParagraphTypography>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box mb={6}>
          <Grid container spacing={0.5}>
            {activePage == 0 &&
              clientsPage1.map((client) => (
                <Grid item key={client.name} lg={4} md={6} sm={6} xs={12}>
                  <TestimonialCard {...client} />
                </Grid>
              ))}
            {activePage == 1 &&
              clientsPage2.map((client) => (
                <Grid item key={client.name} lg={4} md={6} sm={6} xs={12}>
                  <TestimonialCard {...client} />
                </Grid>
              ))}
            {activePage == 2 &&
              clientsPage3.map((client) => (
                <Grid item key={client.name} lg={4} md={6} sm={6} xs={12}>
                  <TestimonialCard {...client} />
                </Grid>
              ))}
            {activePage == 3 &&
              clientsPage4.map((client) => (
                <Grid item key={client.name} lg={4} md={6} sm={6} xs={12}>
                  <TestimonialCard {...client} />
                </Grid>
              ))}
          </Grid>
        </Box>

        <div className="navigationContainer">
          <img
            src={activePage == 0 ? leftDisabledArrow : leftArrow}
            onClick={previousPage}
          />
          <p className="font-16 font-inter-regular font-black1">
            {activePage + 1} of 4
          </p>
          <img
            src={activePage == 3 ? rightDisabledArrow : rightArrow}
            onClick={nextPage}
          />
        </div>
      </Container>

      <Box className={classes.requestDemoRoot} py={12} textAlign="center">
        <Box alignItems="center" display="flex" justifyContent="center">
          <HeaderTypography
            color="common.white"
            fontSize={40}
            my={0}
            textAlign="center"
          >
            Join our happy customers and
            <br /> increase your sales revenue
          </HeaderTypography>
        </Box>
        <Box mt={6} textAlign="center">
          <WhiteButton
            color="primary"
            component={Link}
            size="large"
            to="/contact/?utm_source=Testimonials&utm_medium=Book+a+free+demo"
            variant="contained"
          >
            Book a free demo
          </WhiteButton>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default TestimonialPage;
